import React from 'react';
import { useCart } from '@/context/cart/CartContext';
import CartButton from './Button';
const Cart = () => {
  const { cart } = useCart();
  return <CartButton cart={cart} />;
};

export default Cart;
